import { render, staticRenderFns } from "./new_accos.vue?vue&type=template&id=706208ba&scoped=true"
import script from "./new_accos.vue?vue&type=script&lang=js"
export * from "./new_accos.vue?vue&type=script&lang=js"
import style0 from "./new_accos.vue?vue&type=style&index=0&id=706208ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706208ba",
  null
  
)

export default component.exports